import { render } from "./CustomSectionIcon.vue?vue&type=template&id=765dcd25"
import script from "./CustomSectionIcon.vue?vue&type=script&lang=js"
export * from "./CustomSectionIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__